import script from "./ListasView.vue?vue&type=script&setup=true&lang=js"
export * from "./ListasView.vue?vue&type=script&setup=true&lang=js"

import "./ListasView.vue?vue&type=style&index=0&id=3d88ef77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d88ef77"]])

export default __exports__